import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

const FeeFilter = ({
  lazyParams,
  onSearch,
  classes,
  onClassFilter,
  feeTypeOptions,
  onFeeTypeFilter,
  openNew
}) => {
  return (
    <div className="mb-2 flex-shrink-0">
      <div className="bg-white/80 backdrop-blur-xl rounded-xl shadow-lg border border-white/20 p-4 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-400/10 to-purple-500/10 rounded-full -translate-y-16 translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full translate-y-12 -translate-x-12"></div>

        <div className="flex items-center justify-between mb-4 relative z-10">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-lg">
              <i className="pi pi-money-bill text-white text-sm"></i>
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-900">Fee Management</h3>
              <p className="text-xs text-gray-600 mt-0.5">Manage fee structures and academic charges</p>
            </div>
          </div>

          <button onClick={openNew} className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl text-sm">
            <i className="pi pi-plus text-sm"></i> Add Fee Structure
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 relative z-10">
          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-search mr-1 text-indigo-500 text-xs"></i>Search</label>
            <InputText value={lazyParams.globalFilter} onChange={onSearch} placeholder="Search..." className="w-full pl-3 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/20 transition-all duration-200" />
          </div>

          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-book mr-1 text-emerald-500 text-xs"></i>Class</label>
            <Dropdown value={lazyParams.classId} options={classes.map(c => ({ label: c.name || c.className, value: c.id }))} onChange={onClassFilter} placeholder="Select Class" className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
          </div>

          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-tag mr-1 text-purple-500 text-xs"></i>Fee Type</label>
            <Dropdown value={lazyParams.feeType} options={feeTypeOptions} onChange={onFeeTypeFilter} placeholder="Select Fee Type" className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeFilter;
